/* 中文词典：debug 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const debug = {
  'debug.index.title': [ '象牙轮盘 · 调试页' ],
  'debug.index.intro': [ '这些页面<strong>不是游戏界面</strong>，是用来单独调某一级的工具。\n      游戏界面在 <code>/</code>（见 docs/STATUS.md）。' ],
  'debug.index.palette': [ '色板' ],
  'debug.index.paletteNote': [ '色板定义在 <code>src/render/palette.ts</code>。\n      <strong>SIGNAL</strong> 是荧光基色原样（发光用），\n      <strong>STROKE</strong> 是同色相往中灰收过的（线用）——\n      黑底上把线调暗等于让它隐形，所以收的是饱和度不是明度。' ],
  'debug.index.pg.background.name': [ '背景 · 标量场 + 半调' ],
  'debug.index.pg.background.desc': [ '只调背景，没有卡牌层。每个滑块对应一个 uniform' ],
  'debug.index.pg.textures.name': [ '中间数据 · FBO / 纹理' ],
  'debug.index.pg.textures.desc': [ '把平时看不见的中间产物逐格平铺出来' ],
  'debug.index.pg.dying.name': [ '濒死 · 45° 红斜杠横带' ],
  'debug.index.pg.dying.desc': [ '抽到异常牌：牌浮在正中（不进手牌堆）· 黑色半调阴影 · 呼吸红辉光 · 横带往两边跑' ],
  'debug.index.pg.dyingBg.name': [ '濒死期间的背景 · 复现台' ],
  'debug.index.pg.dyingBg.desc': [ '只有背景（标量场 + 半调 + 裂缝遮罩）：濒死期间那三个事件、全部参数、坐标诊断滤镜、节距读数与快照对比' ],
  'debug.index.pg.impact.name': [ '濒死 · 打击（IMPACT）' ],
  'debug.index.pg.impact.desc': [ '抽到异常牌撑满那一刻的那一下：冻结帧 · 白闪 · 反相 · 震动(trauma) · 推镜 · 去色/色差 · 暗角 · 边缘脉冲 —— 每个旋钮一根滑块，空格 = 打一记' ],
  'debug.index.pg.face.name': [ '牌面 · 调优' ],
  'debug.index.pg.face.desc': [ '13 张牌摆一桌，每个可调参数一个滑块（改的是 tune.ts 里的值）' ],
  'debug.index.pg.art.name': [ '美术资产 · 牌背 + 标题 Logo' ],
  'debug.index.pg.art.desc': [ '两个非卡牌资产，和牌面共用同一条 spec 管线' ],
  'debug.index.pg.icon.name': [ '小 Logo · favicon' ],
  'debug.index.pg.icon.desc': [ '透明底 1:1 的 A，一整套尺寸；scripts/icons.mjs 从这一页取图' ],
  'debug.index.pg.cards.name': [ '卡牌渲染' ],
  'debug.index.pg.cards.desc': [ '假透视参数对照表' ],
  'debug.index.pg.hand.name': [ '手牌 · 手感' ],
  'debug.index.pg.hand.desc': [ '空闲摇摆 · hover 面向鼠标 · 按下 · 扇形整体上移与邻居避让 · 移动方向的倾角与限速' ],
  'debug.index.pg.full.name': [ '全部合起来' ],
  'debug.index.pg.full.desc': [ '背景 + 濒死 + 卡牌 + 挖洞 + 外发光' ],
  'debug.index.pg.ui.name': [ 'UI · 组件与状态语汇' ],
  'debug.index.pg.ui.desc': [ '四个变体 × 四种状态铺在一起 —— 规范里"hover 只加墨"这条，只有并排才验得了' ],
  'debug.index.pg.bgm.name': [ 'BGM · 动态音乐 + 节拍同步' ],
  'debug.index.pg.bgm.desc': [ 'BgmDirector 驱动 zenith 乐谱：脉冲圆每 2 小节卡点一次，切曲对齐小节边界，isDying 上升沿拉回开头' ],
  'debug.shared.back': [ '← 调试目录' ],
  'debug.ui.title': [ 'UI · 组件与状态语汇' ],
  'debug.ui.subtitle': [ 'docs/ui-design.md 的那张表，铺出来看' ],
  'debug.ui.statesTitle': [ '状态语汇 · 每个变体 × 四种状态' ],
  'debug.ui.lift': [ '抬起 ', { type: 'param', name: 'px' }, 'px' ],
  'debug.ui.liftNote': [ 'hover 抬起 ', { type: 'param', name: 'lift' }, 'px（整块，含文字）· press 下沉 ', { type: 'param', name: 'press' }, 'px · 过渡 ', { type: 'param', name: 'range' }, 'ms 急停，不过冲' ],
  'debug.ui.barsTitle': [ '信号条 · 打样页的 .uibar' ],
  'debug.ui.barWait': [ '等待响应 · 有人还没表态' ],
  'debug.ui.barDraw': [ '致命响应窗口 · 有人抽到了异常' ],
  'debug.ui.hazardNote': [ '危险条纹只有两个出处：白卡底边 + 这里。用第二次就变成套路 —— 不再是威胁。' ],
  'debug.ui.chromeTitle': [ '装置' ],
  'debug.ui.notice': [ { type: 'param', name: 'tone' }, ' · 一条通栏提示' ],
  'debug.ui.readout': [ 'ROM 000', { type: 'param', name: 'n' }, ' · 一条机读行（等宽小字、低对比、带序号）' ],
  'debug.ui.operatorLabel': [ '开销后房主' ],
  'debug.ui.operatorValue': [ 'OPERATOR-0000（网络最快）' ],
  'debug.ui.aliveTitle': [ '活控件 · 把鼠标移上去看 hover' ],
  'debug.ui.btn.primary': [ '主操作' ],
  'debug.ui.btn.secondary': [ '次操作' ],
  'debug.ui.btn.quiet': [ '次级入口' ],
  'debug.ui.btn.danger': [ '破坏性' ],
  'debug.ui.btn.disabled': [ '禁用' ],
  'debug.ui.toggleOn': [ '开关（开）' ],
  'debug.ui.toggleOff': [ '开关（关）' ],
  'debug.ui.toggleDisabled': [ '开关（禁用）' ],
  'debug.ui.stepper': [ '步进器' ],
  'debug.ui.slider': [ '滑块' ],
  'debug.ui.panel': [ '面板 / PANEL' ],
  'debug.ui.section': [ '分区标题 / SECTION' ],
  'debug.ui.panelNote': [ '面板高度由 fitContent 算，调用方只报内容高度' ],
  'debug.ui.chromeHeader': [ 'UI 打样 · KIT' ],
  'debug.ui.pressRed': [ 'PRESS.red · 危险条纹与白卡底边共用的那管墨' ],
  'debug.cards.title': [ '卡牌渲染 · 假透视' ],
  'debug.cards.subtitle': [ '每行只变一个参数' ],
  'debug.full.title': [ '全部合起来' ],
  'debug.full.subtitle': [ '背景挖洞 + 濒死横带 + 外发光 + 卡牌' ],
  'debug.full.glow': [ '外发光' ],
  'debug.full.radius': [ '扩散半径' ],
  'debug.full.strength': [ '强度' ],
  'debug.full.hideCards': [ '隐藏卡牌' ],
  'debug.full.begin': [ '进入濒死' ],
  'debug.full.end': [ '解除' ],
  'debug.full.info': [ '牌面 FBO ', { type: 'param', name: 'faces' }, ' 张 · 场上有 ', { type: 'param', name: 'count' }, ' 条扰动' ],
  'debug.icon.title': [ '小 Logo · favicon' ],
  'debug.icon.subtitle': [ '透明底 · 1:1 · 只有字母 A' ],
  'debug.icon.lightTab': [ '浅色标签栏' ],
  'debug.icon.darkTab': [ '深色标签栏' ],
  'debug.icon.caption': [ '小 Logo · 1:1 · 一枚红楔子 · 透明底' ],
  'debug.icon.caption2': [ '上面一行是浏览器里实际看到的像素，下面一行是放大的形状' ],
  'debug.icon.maskable': [ 'maskable-192 · 黄圈 = Android 安全区' ],
  'debug.icon.sizes': [ { type: 'param', name: 'count' }, ' 个尺寸 + favicon.ico（内含 ', { type: 'param', name: 'list' }, '）· node scripts/icons.mjs' ],
  'debug.textures.title': [ '中间数据 · FBO / 纹理' ],
  'debug.textures.subtitle': [ '逐格平铺，用来定位问题出在哪一级' ],
  'debug.textures.noLethal': [ '原版包里没有致命牌' ],
  'debug.textures.footprint': [ '卡牌占地遮罩 (footprint.mask)' ],
  'debug.textures.background': [ '背景 · 标量场 + 半调（两级 filter 之后的成品）' ],
  'debug.textures.face': [ '牌面 FBO · 含出血（牌高 ', { type: 'param', name: 'height' }, '）' ],
  'debug.textures.dyingField': [ '濒死 · 那片光（牌形剪影 + 大范围模糊）' ],
  'debug.textures.dyingShadow': [ '濒死 · 黑色半调阴影（= 上面那张上半调滤镜，镂空模式）' ],
  'debug.textures.reload': [ '重新读一遍' ],
  'debug.art.title': [ '美术资产 · 牌背 + 标题 Logo' ],
  'debug.art.subtitle': [ '都和牌面共用一条 spec 管线' ],
  'debug.art.backCaption': [ '牌背 · 一排里读不读得出是同一个背面（零酸色）' ],
  'debug.art.titleCaption': [ '标题 Logo · ACID SAMIZDAT（透明底，压在中灰上）' ],
  'debug.art.backNote': [ '牌背中央：同一张"牌"印了两遍，第二遍偏了 ', { type: 'param', name: 'offset' }, '（两块没对准的版）' ],
  'debug.art.titleNote': [ '设计空间 ', { type: 'param', name: 'w' }, '×', { type: 'param', name: 'h' }, ' · 两行齐宽到 ', { type: 'param', name: 'measure' }, '（量出来的，不是猜字号）' ],
  'debug.art.weave': [ '牌背 · 织纹（线屏 × 点屏 = 摩尔纹）' ],
  'debug.art.sigil': [ '牌背 · 中央标记 + 角标' ],
  'debug.art.titlePanel': [ '标题 Logo' ],
  'debug.art.wedge': [ '红楔子（Logo / favicon 共用）' ],
  'debug.art.dump': [ '导出参数（打印到 console）' ],
  'debug.impact.title': [ '濒死 · 打击' ],
  'debug.impact.subtitle': [ '冻结 / 白闪 / 反相 / 震动 / 推镜 / 去色·色差 / 暗角 / 边缘脉冲 —— 方案见 docs/dying-impact.md' ],
  'debug.impact.style': [ 'ImpactStyle（改的是内存，导出后抄回去）' ],
  'debug.impact.replay': [ '重放' ],
  'debug.impact.land': [ '落地 kick' ],
  'debug.impact.hit': [ '★ 主打击' ],
  'debug.impact.riser': [ '只渐强（riser）' ],
  'debug.impact.burst': [ '炸一把粒子' ],
  'debug.impact.bar': [ '边缘脉冲' ],
  'debug.impact.reset': [ '重置' ],
  'debug.impact.auto': [ '自动每 2.5s 打一记' ],
  'debug.impact.beatAlign': [ '主打击对齐到下一小节（B4）' ],
  'debug.impact.dyingOn': [ '濒死层开着' ],
  'debug.impact.glitchOn': [ '挂故障滤镜' ],
  'debug.impact.glitch': [ '故障滤镜' ],
  'debug.impact.strength': [ '强度' ],
  'debug.impact.readout': [ '读数' ],
  'debug.impact.export': [ '导出' ],
  'debug.impact.dump': [ '导出参数' ],
  'debug.bg.title': [ '背景 · 标量场 + 半调' ],
  'debug.bg.subtitle': [ '没有卡牌层' ],
  'debug.bg.subtitleScale': [ '渲染档位 ', { type: 'param', name: 'scale' }, '（?scale=）' ],
  'debug.bg.field': [ '标量场' ],
  'debug.bg.baseAmp': [ '初始状态 · 明度放大' ],
  'debug.bg.baseBias': [ '初始状态 · 偏置' ],
  'debug.bg.baseScale': [ '初始状态 · 空间频率' ],
  'debug.bg.baseSpeed': [ '初始状态 · 时间倍率' ],
  'debug.bg.windowLow': [ '窗口下界' ],
  'debug.bg.windowHigh': [ '窗口上界' ],
  'debug.bg.halftone': [ '半调' ],
  'debug.bg.dotPitch': [ '网点节距' ],
  'debug.bg.dotAngle': [ '排列角度' ],
  'debug.bg.contrast': [ '网点对比度（二值化的胖瘦）' ],
  'debug.bg.dotShape': [ '点的形状（0圆 1方 2菱 3十字 4横线）' ],
  'debug.bg.stages': [ '阶段' ],
  'debug.bg.stageField': [ '标量场' ],
  'debug.bg.stageHalftone': [ '半调' ],
  'debug.bg.pause': [ '暂停时间' ],
  'debug.bg.spawnRipple': [ '水波纹' ],
  'debug.bg.spawnSwirl': [ '漩涡' ],
  'debug.bg.spawnPulse': [ '脉动' ],
  'debug.bg.spawnWave': [ '行波' ],
  'debug.bg.clear': [ '清空' ],
  'debug.bg.barAccent': [ '▸ Bar 脉冲（重音）' ],
  'debug.bg.barWeak': [ '▸ Bar 脉冲（弱）' ],
  'debug.bg.infoScale': [ '档位 ', { type: 'param', name: 'scale' }, '（', { type: 'param', name: 'mode' }, '）' ],
  'debug.bg.hardEdge': [ ' · 1-bit 硬边' ],
  'debug.bg.softEdge': [ ' · 柔边' ],
  'debug.bg.infoField': [ '场上有 ', { type: 'param', name: 'count' }, ' 条扰动 · 时间 ', { type: 'param', name: 'time' }, 's' ],
  'debug.bg.readout': [ '灰阶读数 min ', { type: 'param', name: 'min' }, ' · mean ', { type: 'param', name: 'mean' }, ' · max ', { type: 'param', name: 'max' } ],
  'debug.bg.flat': [ '  ← 场是平的' ],
  'debug.face.title': [ '牌面 · 调优' ],
  'debug.face.subtitle': [ '数字全在 src/render/card/art/tune.ts' ],
  'debug.face.heading': [ '牌面调优 · 13 张摆在一张桌子上' ],
  'debug.face.warm': [ '牌高 ', { type: 'param', name: 'height' }, ' · 预热 ', { type: 'param', name: 'count' }, ' 张 ', { type: 'param', name: 'ms' }, 'ms（烘焙 ', { type: 'param', name: 'bakes' }, ' 次）· 之后整局不再增长' ],
  'debug.face.cache': [ { type: 'param', name: 'cards' }, ' 张唯一牌 · 牌面 FBO ', { type: 'param', name: 'fbo' }, ' 张 · 烘焙 ', { type: 'param', name: 'bakes' }, ' 次 / 摆放 ', { type: 'param', name: 'sprites' }, ' 次 —— 复用在生效' ],
  'debug.face.bleed': [ '出血（牌外那一圈）' ],
  'debug.face.padFade': [ 'padFade 淡出（关掉 = 保留硬裁的对照）' ],
  'debug.face.hand': [ '手绘' ],
  'debug.face.jitter': [ '抖幅 HAND.jitter' ],
  'debug.face.press': [ '笔压 HAND.press' ],
  'debug.face.print': [ '印刷（网点）' ],
  'debug.face.printPitch': [ '间距 PRINT.pitch' ],
  'debug.face.printAngle': [ '网角 PRINT.angle' ],
  'debug.face.printCoverage': [ '覆盖 PRINT.coverage' ],
  'debug.face.hazard': [ '危险条纹（异常底部 + 将来的濒死横带）' ],
  'debug.face.hazardPitch': [ '间距 hazard.pitch' ],
  'debug.face.hazardAngle': [ '角度 hazard.angle' ],
  'debug.face.hazardDuty': [ '占空 hazard.duty' ],
  'debug.face.exception': [ '异常 · 白卡（唯一一张）' ],
  'debug.face.dump': [ '导出参数（打印到 console）' ],
  'debug.dying.title': [ '濒死 · 45° 红斜杠横带' ],
  'debug.dying.subtitle': [ '抽到异常牌：牌浮在正中 · 黑色半调阴影 · 呼吸红辉光 · 横带往两边跑' ],
  'debug.dying.noCard': [ '原版包里没有 ', { type: 'param', name: 'local' } ],
  'debug.dying.noLethal': [ '原版包里没有致命牌' ],
  'debug.dying.trigger': [ '触发' ],
  'debug.dying.begin': [ '进入濒死 begin()' ],
  'debug.dying.end': [ '解除 end()' ],
  'debug.dying.pulse': [ '闪一下 pulse()' ],
  'debug.dying.barPulse': [ '▸ 小节重音 barPulse(1)' ],
  'debug.dying.crackGrow': [ '▸ 裂缝重长 cracks.begin()' ],
  'debug.dying.crackClose': [ '裂缝合上 cracks.end()' ],
  'debug.dying.override': [ '强度覆盖（-1 = 关）' ],
  'debug.dying.layers': [ '分层开关' ],
  'debug.dying.layerBg': [ '背景' ],
  'debug.dying.layerBand': [ '① 警示横带' ],
  'debug.dying.layerGlow': [ '② 红色外发光' ],
  'debug.dying.layerHalo': [ '③ 黑色半调阴影' ],
  'debug.dying.layerHero': [ '④ 悬浮的异常牌' ],
  'debug.dying.layerFootprint': [ '卡牌占地外发光' ],
  'debug.dying.layerCrack': [ '裂缝遮罩（把场置零的那一层）' ],
  'debug.dying.layerCrackView': [ '裂缝遮罩 · 直接显示（调形状用）' ],
  'debug.dying.bandHeight': [ '高度' ],
  'debug.dying.bandPitch': [ '间距' ],
  'debug.dying.bandDuty': [ '占空' ],
  'debug.dying.bandSpeed': [ '速度（相位/秒）' ],
  'debug.dying.bandMirror': [ 'bandMirror · 右半边镜像（关 = 平移，斜杠倾斜方向相同）' ],
  'debug.dying.glowPanel': [ '② 那片光（红光 + 黑阴影共用）' ],
  'debug.dying.silhouetteGrow': [ '剪影比牌大（每边）' ],
  'debug.dying.glowBlur': [ '模糊半径（= 阴影有多大）' ],
  'debug.dying.glowAlphaMin': [ '呼吸最低' ],
  'debug.dying.glowAlphaMax': [ '呼吸最高' ],
  'debug.dying.breathPeriod': [ '呼吸周期（秒）' ],
  'debug.dying.crackPanel': [ '④ 裂缝遮罩' ],
  'debug.dying.crackLineWidth': [ '线宽（场被置零的那一条有多宽）' ],
  'debug.dying.crackArms': [ '条数' ],
  'debug.dying.crackGrowSeconds': [ '长满要多久（秒）' ],
  'debug.dying.crackStagger': [ '逐条错开（秒）' ],
  'debug.dying.shadowPanel': [ '③ 黑色半调阴影（= ②上半调滤镜）' ],
  'debug.dying.shadowPitch': [ '网点间距' ],
  'debug.dying.shadowAngle': [ '网角（弧度）' ],
  'debug.dying.shadowContrast': [ '网点对比（越大网点越分开）' ],
  'debug.dying.shadowHint': [ '⚠️ 阴影的网点和背景那层（11px / 45°）错开，否则两层网点会叠出摩尔纹。改完满意了，数字抄回 src/render/dying/layer.ts。' ],
  'debug.dyingBg.title': [ '濒死期间的背景 · 复现台' ],
  'debug.dyingBg.subtitle': [ '只有背景：标量场 + 半调 + 裂缝遮罩。没有卡牌、没有濒死层、没有故障滤镜' ],
  'debug.dyingBg.events': [ '事件（濒死期间真的会发生的三件事）' ],
  'debug.dyingBg.begin': [ '进入濒死 begin()' ],
  'debug.dyingBg.end': [ '解除 end()' ],
  'debug.dyingBg.barAccent': [ '▸ Bar（重音 1.0）' ],
  'debug.dyingBg.barWeak': [ '▸ Bar（弱 0.62）' ],
  'debug.dyingBg.autoBar': [ '自动 Bar（按小节敲，模拟 BGM）' ],
  'debug.dyingBg.barSeconds': [ '小节长度（秒）' ],
  'debug.dyingBg.autoCycle': [ '自动循环濒死（进 6 秒 → 出 3 秒）' ],
  'debug.dyingBg.glitchPanel': [ '故障滤镜（挂在 world 上，和游戏一样）' ],
  'debug.dyingBg.glitchOn': [ '开着（游戏里只在濒死期间开）' ],
  'debug.dyingBg.glitchStrength': [ '强度' ],
  'debug.dyingBg.glitchHint': [ '⚠️ 滤镜的中间贴图默认按**逻辑尺寸**申请（Pixi 的 Filter.resolution 默认 1）—— DPR 2 的屏幕上，整块画面会先在 1280×800 里画一遍再放大两倍。' ],
  'debug.dyingBg.crackPanel': [ '裂缝（濒死那一张遮罩，它改的是场）' ],
  'debug.dyingBg.crackGrow': [ '重长 cracks.begin()' ],
  'debug.dyingBg.crackClose': [ '合上 cracks.end()' ],
  'debug.dyingBg.crackLineWidth': [ '线宽' ],
  'debug.dyingBg.crackArms': [ '条数' ],
  'debug.dyingBg.crackGrowSeconds': [ '长满要多久（秒）' ],
  'debug.dyingBg.crackStrength': [ '裂缝强度' ],
  'debug.dyingBg.moodPanel': [ '情绪（energy → 亮度 / 色调 / 时间倍率）' ],
  'debug.dyingBg.brightnessOverride': [ '亮度覆盖（-1 = 关）' ],
  'debug.dyingBg.timeScale': [ '时间倍率（0 = 冻住）' ],
  'debug.dyingBg.fieldPanel': [ '标量场（阶段一）' ],
  'debug.dyingBg.baseAmp': [ '初始状态 · 明度放大' ],
  'debug.dyingBg.baseBias': [ '初始状态 · 偏置' ],
  'debug.dyingBg.baseScale': [ '初始状态 · 空间频率' ],
  'debug.dyingBg.windowLow': [ '窗口下界' ],
  'debug.dyingBg.windowHigh': [ '窗口上界' ],
  'debug.dyingBg.fieldClear': [ '清空扰动' ],
  'debug.dyingBg.halftonePanel': [ '半调（阶段二）' ],
  'debug.dyingBg.dotPitch': [ '网点节距' ],
  'debug.dyingBg.dotAngle': [ '排列角度' ],
  'debug.dyingBg.contrast': [ '网点对比度' ],
  'debug.dyingBg.softness': [ '边缘柔度（只对柔边档有效）' ],
  'debug.dyingBg.dotShape': [ '点的形状（0圆 1方 2菱 3十字 4横线）' ],
  'debug.dyingBg.diagPanel': [ '诊断（换掉半调那一级）' ],
  'debug.dyingBg.diagModes': [ '0关 1场 2四边形 3画布 4格子 5像素格 6取样坐标' ],
  'debug.dyingBg.diagHint': [ '「取样坐标」最有用：铺满 0..1 才说明纹理池给的贴图和滤镜区域一样大；只铺到 0.5 就说明那张图比区域大一倍 —— 任何拿 uv 当屏幕坐标算的着色器都会错一倍。' ],
  'debug.dyingBg.statsPanel': [ '读数 / 快照对比' ],
  'debug.dyingBg.read': [ '读一次' ],
  'debug.dyingBg.snapshot': [ '存快照（拿现在当基准）' ],
  'debug.dyingBg.clearSnapshot': [ '清快照' ],
  'debug.dyingBg.dyingYes': [ '中' ],
  'debug.dyingBg.dyingNo': [ '否' ],
  'debug.dyingBg.infoDying': [ '濒死 ', { type: 'param', name: 'state' }, ' · Bar 敲了 ', { type: 'param', name: 'n' }, ' 次' ],
  'debug.dyingBg.infoScale': [ '档位 ', { type: 'param', name: 'scale' }, '（', { type: 'param', name: 'mode' }, '）' ],
  'debug.dyingBg.infoMood': [ '情绪 亮度 ', { type: 'param', name: 'brightness' }, ' 闪 ', { type: 'param', name: 'flash' } ],
  'debug.dyingBg.infoTime': [ '时间倍率 ', { type: 'param', name: 'time' }, ' · 扰动 ', { type: 'param', name: 'count' }, ' 条' ],
  'debug.dyingBg.autoBarOn': [ ' · 自动 Bar 开' ],
  'debug.dyingBg.brightnessOverridden': [ ' · 亮度被覆盖' ],
  'debug.dyingBg.notRead': [ '（还没读）' ],
  'debug.dyingBg.rowCoverage': [ '覆盖率%' ],
  'debug.dyingBg.rowGrayMean': [ '右上灰阶' ],
  'debug.dyingBg.rowCells': [ '格子数' ],
  'debug.dyingBg.rowCellPx': [ '格子px' ],
  'debug.dyingBg.rowRuns': [ '点数' ],
  'debug.dyingBg.rowRunPx': [ '点宽px' ],
  'debug.dyingBg.rowScreen': [ '屏幕' ],
  'debug.dyingBg.rowInnerSize': [ '里层 size' ],
  'debug.dyingBg.rowInnerScale': [ '里层 scale' ],
  'debug.dyingBg.rowViewSize': [ 'view 实测' ],
  'debug.dyingBg.diffHeader': [ '—— 相对快照 ——' ],
  'debug.dyingBg.rowCoverageDiff': [ '覆盖率' ],
  'debug.bgm.events': [ '事件流（音频时刻 / 收到时刻）' ],
  'debug.bgm.title': [ 'BGM 调试台 · BgmDirector + zenith 乐谱' ],
  'debug.bgm.intro': [ '脉冲圆每次 phrase（2 小节）跳一次，四个点是每拍。切换按钮在小节边界才生效。audio 是精灵图，只播循环区间 —— 见 ' ],
  'debug.bgm.period': [ '。' ],
  'debug.bgm.phrase': [ '#', { type: 'param', name: 'n' }, '（每 ', { type: 'param', name: 'bars' }, ' 小节）' ],
  'debug.bgm.restart': [ '音乐回到循环起点' ],
  'debug.bgm.source': [ '实际用的' ],
  'debug.bgm.supported': [ '支持' ],
  'debug.bgm.unsupported': [ '不支持' ],
  'debug.bgm.notLoaded': [ '（还没加载）' ],
  'debug.bgm.paramFinal': [ 'isFinal → ', { type: 'param', name: 'value' }, '（下一小节生效）' ],
  'debug.hand.title': [ '手牌 · 手感' ],
  'debug.hand.subtitle': [ '空闲摇摆 · hover 上下左右转向鼠标 · 按下 · 点选 · 拖动换位 · 拖出去打出' ],
  'debug.hand.played': [ '打出 ', { type: 'param', name: 'cards' } ],
  'debug.hand.shapePanel': [ '摆法 · 自动推导' ],
  'debug.hand.count': [ '张数（改它会重建 CardView）' ],
  'debug.hand.curl': [ 'curl · 想弯多少（单位：牌高）' ],
  'debug.hand.fill': [ 'fill · 最多占画布多宽' ],
  'debug.hand.shapeNote': [ '⚠️ 弧心 x、y、间距、倾角倍率都**不是**旋钮：它们由画布尺寸 + 牌尺寸 + 张数推出来。curl 超过 0.5 之后画面不再变化 —— 那是"边缘牌至少露出一半"这条规则卡住的。' ],
  'debug.hand.idlePanel': [ '① 空闲：缓慢地晃' ],
  'debug.hand.idleRollAmp': [ '左右摇摆幅度（度）' ],
  'debug.hand.idlePitchAmp': [ 'pitch 幅度（度）' ],
  'debug.hand.idlePitchPhase': [ 'pitch 相位差（90 = 顺时针画圈）' ],
  'debug.hand.idlePeriod': [ '周期（秒）' ],
  'debug.hand.idlePhaseStep': [ '相邻两张的相位差（度）' ],
  'debug.hand.hoverPanel': [ '② hover' ],
  'debug.hand.hoverScale': [ '放大多少' ],
  'debug.hand.hoverLift': [ '自己再抬多少（牌高）' ],
  'debug.hand.hoverPitch': [ '上下转向鼠标的增益（度）' ],
  'debug.hand.hoverYaw': [ '★ 左右转向鼠标的增益（度）' ],
  'debug.hand.hoverFaceRef': [ '上面两个"一个单位"= 几个牌高' ],
  'debug.hand.pressPanel': [ '③ 按下 / 选中' ],
  'debug.hand.pressScale': [ '按下再放大多少' ],
  'debug.hand.pressLift': [ '按下再抬多少（牌高）' ],
  'debug.hand.selectLift': [ '★ 选中抬多高（牌高）' ],
  'debug.hand.selectScale': [ '★ 选中放大多少' ],
  'debug.hand.fanLift': [ '整手牌上移（牌高）' ],
  'debug.hand.avoidPanel': [ '④ 邻居避让' ],
  'debug.hand.avoid': [ '紧邻让开多少（牌宽）' ],
  'debug.hand.avoidFalloff': [ '隔一张剩多少' ],
  'debug.hand.scalePanel': [ '⑤ 大小' ],
  'debug.hand.scaleRate': [ '追目标的快慢（1/秒）' ],
  'debug.hand.scaleNote': [ '⚠️ 大小和位置一样只做**单调**趋近 —— 不越过目标、不抖。试过一版欠阻尼弹簧（"抖一两下"），评审说不好看，删了。' ],
  'debug.hand.followPanel': [ '⑥ 跟随' ],
  'debug.hand.followRate': [ '位置追目标的快慢（1/秒）' ],
  'debug.hand.angleRate': [ '★ 角度（yaw/pitch/roll）追目标的快慢' ],
  'debug.hand.maxSpeed': [ '最大移动速度（牌高/秒，0 = 不限）' ],
  'debug.hand.followNote': [ '⚠️ 角度也必须平滑：位置是滑过去的、倾角却是瞬间跳一格的话，一眼就看出是两套东西在动。' ],
  'debug.hand.envPanel': [ '⑦ 包络' ],
  'debug.hand.riseRate': [ 'hover/按下进来的快慢（1/秒）' ],
  'debug.hand.fallRate': [ 'hover/按下出去的快慢（1/秒）' ],
  'debug.hand.avoidRiseRate': [ '★ 邻居避让进来的快慢（1/秒）' ],
  'debug.hand.avoidFallRate': [ '★ 邻居避让出去的快慢（1/秒）' ],
  'debug.hand.musicPanel': [ '⑧ 音乐脉动（Bar 事件）' ],
  'debug.hand.barPulseScale': [ '立即放大多少' ],
  'debug.hand.barPulseRate': [ '缩回去的快慢（1/秒）' ],
  'debug.hand.musicNote': [ '⚠️ 放大是**硬起**的（不走平滑）、缩回去才 easeout。主界面里由 BgmDirector 的 Bar 事件驱动（`ui/beat.ts`）；这一页下面的按钮只是调参用的手动入口。' ],
  'debug.hand.opsPanel': [ '操作' ],
  'debug.hand.barPulse': [ '▸ Bar 脉动' ],
  'debug.hand.reset': [ '放回原位' ],
  'debug.hand.selectAll': [ '全选' ],
  'debug.hand.clearSelection': [ '清空选中' ],
  'debug.hand.export': [ '导出参数' ],
  'debug.hand.hint': [ '操作：**点一下**选中、再点一下取消（可多选）；按住已选中的那张拖 = 整组一起走；左右拖 = 换位（实时让开）；拖到手牌上方那条线以上松手 = **打出**。点空白 = 清空选中。⚠️ 角度参数一律是**度**、长度一律是**比例**（feel.ts 的文件头写了为什么）。' ],
  'debug.hand.readout.card': [ '牌 ', { type: 'param', name: 'w' }, '×', { type: 'param', name: 'h' }, '（长度比例的基准）' ],
  'debug.hand.readout.layout': [ '布局 间距 ', { type: 'param', name: 'spread' }, ' · 弯 ', { type: 'param', name: 'droop' }, ' / 想要 ', { type: 'param', name: 'wanted' }, ' / 倾角上限 ', { type: 'param', name: 'limit' }, ' 牌高' ],
  'debug.hand.readout.center': [ '弧心 (', { type: 'param', name: 'x' }, ', ', { type: 'param', name: 'y' }, ') · 倾角倍率 ', { type: 'param', name: 'gain' } ],
  'debug.hand.readout.order': [ '位次 ', { type: 'param', name: 'order' } ],
  'debug.hand.readout.hover': [ 'hover ', { type: 'param', name: 'hovered' }, ' · 按住 ', { type: 'param', name: 'held' }, ' · 选中 [', { type: 'param', name: 'selected' }, '] · 打出的 [', { type: 'param', name: 'played' }, ']' ],
  'debug.hand.readout.pulse': [ '脉动 ', { type: 'param', name: 'pulse' } ],
  'debug.hand.readout.poseHint': [ '（把鼠标放到牌上）' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
debug satisfies Record<string, TextSpec>;
export default debug;
